import { uid } from 'uid'

export default {
  checkout(order) {
    if (!window.ttq) return

    try {
      window.ttq.track('CompletePayment', {
        event_id: uid(32),
        currency: order.currency,
        value: order.value,
        content_name: 'Purchase',
        content_category: 'ecommerce',
        content_ids: order.line_items?.map((item) => item.sku) || [],
        contents:
          order.line_items?.map((item) => ({
            content_id: item.sku,
            content_name: item.name,
            content_category: item.category,
            price: item.price,
            quantity: item.quantity,
          })) || [],
      })
    } catch (error) {
      console.error('[TikTok Pixel] Checkout tracking failed:', error)
    }
  },

  addToCart(product) {
    if (!window.ttq) return

    try {
      window.ttq.track('AddToCart', {
        event_id: uid(32),
        currency: product.currency,
        value: product.value,
        content_name: product.content_name || product.name,
        content_category: product.content_category || product.category,
        content_ids: [product.sku || product.id],
        contents: [
          {
            content_id: product.sku || product.id,
            content_name: product.content_name || product.name,
            content_category: product.content_category || product.category,
            price: product.value,
            quantity: 1,
          },
        ],
      })
    } catch (error) {
      console.error('[TikTok Pixel] Add to cart tracking failed:', error)
    }
  },

  viewContent(product) {
    if (!window.ttq) return

    try {
      window.ttq.track('ViewContent', {
        event_id: uid(32),
        currency: product.currency,
        value: product.value,
        content_name: product.content_name || product.name,
        content_category: product.content_category || product.category,
        content_ids: [product.sku || product.id],
        contents: [
          {
            content_id: product.sku || product.id,
            content_name: product.content_name || product.name,
            content_category: product.content_category || product.category,
            price: product.value,
            quantity: 1,
          },
        ],
      })
    } catch (error) {
      console.error('[TikTok Pixel] View content tracking failed:', error)
    }
  },

  pageVisit() {
    if (!window.ttq) return

    try {
      window.ttq.track('PageView', {
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[TikTok Pixel] Page view tracking failed:', error)
    }
  },
}
